<template>
   <v-card width="400px" class="mt-5 mx-auto" color="grey darken-3">
       <v-card-title class="pb-0">
           <h1 :class="{amharic: am}" style="color: white;">{{ $t('signIn.SIGNIN') }}</h1>
       </v-card-title>
       <v-spacer></v-spacer>
       <v-card-text >
           <v-form>
               <v-text-field
               :class="{amharic: am}" 
               :label="$t('signIn.ENTERPHONE')"
               prepend-icon="mdi-cellphone"
               v-model="phone"
               dark
               :error-messages="phoneErrors"
               required
               @input="$v.phone.$touch()"
               @blur="$v.phone.$touch()"/>
               <span 
               :class="{amharic: am}"
               v-if="!phoneExists && okSignin && !showVerifyCode" 
               style="color: #D500F9; font-size:12px">
               <v-icon small color="#D500F9">mdi-information-outline</v-icon>
               {{ $t('signIn.VERIFYHINT') }} 
               </span>
               <v-progress-linear
                   v-if="okSignin && !phoneExists && !showVerifyCode" 
                   indeterminate
                   rounded
                   height="6"
                   color="purple accent-3">
               </v-progress-linear>
               <span 
               :class="{amharic: am}"
               v-if="!phoneExists && okSignin && phoneSearched" 
               style="color: #FFC107; font-size:12px">
               <v-icon small color="amber">mdi-alert</v-icon>
               {{ $t('signIn.NEWPHONE') }}
               </span>
               <v-text-field 
               :class="{amharic: am}"
               v-if="showVerifyCode" 
               :label="$t('signIn.ENTERSMSCODE')"
               v-model="verifyCode"
               dark></v-text-field>
               <span
               :class="{amharic: am}" 
               v-if="smsFailed" 
               style="color: #FFC107; font-size:12px">
               <v-icon small color="#FFC107">mdi-alert</v-icon>
               {{ $t('signIn.SMSFAILED') }}
               </span>
           </v-form>
           <p 
           v-if="verifyError"
           :class="{amharic: am}" 
           style="color: #FFC107; font-size:12px">{{ $t('signIn.BADSMSCODE') }}</p>
       </v-card-text>
       <v-card-actions>
           <v-btn 
           :class="{amharic: am}"
           v-if="!showVerifyCode"
           color="white" 
           type="submit" 
           v-on:submit.prevent="smsAuthenticate" 
           @click="smsAuthenticate" 
           id="sign-in-button"
           :disabled="$v.$invalid">{{ $t('signIn.VERIFY') }}</v-btn>
           <v-btn 
           :class="{amharic: am}"
           v-if="showVerifyCode" 
           color="white"  
           @click="signIn" >{{ $t('signIn.SIGNIN') }}</v-btn>
       </v-card-actions>
   </v-card>
</template>

<script>
import { required,maxLength,minLength } from 'vuelidate/lib/validators';
import { firebaseAuthMixins } from './mixins/firebaseAuth';
export default {
    mixins: [
        firebaseAuthMixins,
    ],
    validations: {
        phone: {
            required,
            // numeric,
            minLen: minLength(12),
            maxLen:maxLength(12),
        },
    },
    data() {
        return {
            // password: '',
            // showPassword: false,
        };
    },
    methods: {
        smsAuthenticate() {
            this.$store.dispatch('auth/smsAuthenticate',this.phone)
        },
        signIn() {
            this.$store.dispatch('auth/signIn',this.verifyCode)
        },
    },
    computed: {
        phoneErrors() {
            const errors = []
            if (!this.$v.phone.$dirty) return errors
            // !this.$v.phone.numeric && errors.push('Phone number can have only numerics')
            !this.$v.phone.required && errors.push(this.$t('signIn.PHONEREQERROR'))
            if (!this.$v.phone.minLen || !this.$v.phone.maxLen) errors.push(this.$t('signIn.PHONEDIGITSERROR'))
            return errors
        },
        okSignin() {
            return this.$v.$invalid ? false : true
        },
        am() {
            // eslint-disable-next-line no-console
            // console.log("locale is :", this.$i18n.locale)
            return this.$i18n.locale === 'አማ' ? true : false 
        }
    },
    watch: {
        'user': function(){ this.$store.dispatch('auth/signInRouter') } 
    },
    
}
</script>